import { Link } from "react-router-dom";
import { SERVICES, BRAND } from "@/data/services";

export default function Footer() {
  return (
    <footer
      className="bg-zinc-950 text-zinc-400 mt-0"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-zinc-500">
              {BRAND.tagline}
            </div>
            <h3 className="font-display text-3xl md:text-4xl text-white mt-4 max-w-md leading-tight">
              Precise CAD drafting for licensed surveyors in all 50 states.
            </h3>
            <div className="mt-6 flex gap-2">
              <Link
                to="/contact"
                className="px-5 py-3 bg-white text-zinc-950 text-sm font-medium btn-lift"
                data-testid="footer-cta-contact"
              >
                Get Started
              </Link>
              <Link
                to="/free-trial"
                className="px-5 py-3 border border-zinc-700 text-white text-sm font-medium btn-lift hover:bg-zinc-900"
                data-testid="footer-cta-free-trial"
              >
                Try for free
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Services
            </div>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(0, 7).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="hover:text-white"
                    data-testid={`footer-svc-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/services" className="text-white underline">
                  View all 13 →
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Company
            </div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/process" className="hover:text-white">Process</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/free-trial" className="hover:text-white">Free Trial</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Contact
            </div>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/contact"
                  className="hover:text-white break-all"
                  data-testid="footer-email"
                >
                  cad4surveysusa@gmail.com
                </Link>
              </li>
              <li>
                <a
                  href={BRAND.tel_url}
                  className="hover:text-white inline-flex items-center gap-1.5"
                  data-testid="footer-phone"
                >
                  {BRAND.phone_display}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.whatsapp_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white inline-flex items-center gap-1.5"
                  data-testid="footer-whatsapp"
                >
                  <span className="inline-block w-2 h-2 bg-[#25D366] rounded-full" aria-hidden="true" />
                  WhatsApp
                </a>
              </li>
              <li className="pt-2 text-zinc-500">Serving all 50 US States</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-zinc-800 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div className="inline-block" data-testid="footer-wordmark">
            <div className="font-display text-6xl md:text-8xl lg:text-9xl text-white leading-none tracking-tighter">
              cad4surveys
            </div>
            <div
              className="block mt-3 md:mt-5 font-mono text-[10px] md:text-xs uppercase text-zinc-400 text-justify [text-align-last:justify]"
              data-testid="footer-slogan"
            >
              Accurate Surveys · Detail-Driven CAD Support
            </div>
          </div>
          <div className="text-xs font-mono text-zinc-500">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
